/**
 * Status Chip displays a message and an indicator
 * "settled" indicates if the status is in transition or not
 * If not settled, the indicator will animate
 */
export default function StatusChip({
  text,
  status,
  settled = false,
}: {
  text: string;
  status: 'neutral' | 'success' | 'error' | 'warning' | 'info';
  settled?: boolean;
}) {
  return (
    <div className="flex items-center gap-2">
      <div
        className={`h-2 w-2 rounded-full ${settled ? '' : 'animate-ping'} ${
          status === 'success'
            ? 'bg-green-500'
            : status === 'error'
              ? 'bg-red-500'
              : status === 'warning'
                ? 'bg-yellow-500'
                : status === 'info'
                  ? 'bg-blue-500'
                  : 'bg-gray-500'
        }`}
      />
      <span className={`text-sm`}>{text}</span>
    </div>
  );
}
